import { Link } from "react-router-dom";

export const SmartLink = ({ href, children, ...rest }) =>
  href.startsWith("/") && !href.includes("#") ? <Link to={href} {...rest}>{children}</Link> : <a href={href} {...rest}>{children}</a>;
